var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 0 0 63 18 63 18 18 63 18 63 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144 0 81 0 81 18 126 18 126 63 144 63 144 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144 144 144 81 126 81 126 126 81 126 81 144 144 144"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 144 63 144 63 126 18 126 18 81 0 81 0 144"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.2,29.15c-13.41,0-24.31,10.91-24.31,24.31v2.5h14.69v-2.5c0-5.3,4.31-9.62,9.62-9.62s9.62,4.31,9.62,9.62-4.31,9.62-9.62,9.62h-7.37v26.81h14.72v-13.25c10.05-3.17,16.96-12.53,16.96-23.18,0-13.41-10.91-24.31-24.31-24.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.2,94.85c-5.35,0-9.7,4.35-9.7,9.7s4.35,9.7,9.7,9.7,9.7-4.35,9.7-9.7-4.35-9.7-9.7-9.7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnHelp);
export default __webpack_public_path__ + "static/media/btn_help.fc783a179c3ba01d07c0c660781c734e.svg";
export { ForwardRef as ReactComponent };